import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const AssessMentSuggestionRecords = ({
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
  isHavingAssessmentSuggestions,
  setIsHavingAssessmentSuggestions
}) => {
  const [tempHtml, setTempHtml] = useState('')
  const [originalHtml, setOriginalHtml] = useState('')
  // const [isHavingAssessmentSuggestions, setIsHavingAssessmentSuggestions] = useState(false)

  useEffect(() => {
    if (!diagnosisName) return

    const savedHtml =
      patientDBdata?.currentNote?.data?.freeTypesEverything?.assessmentFreetype?.[diagnosisName]

    const rawText =
      patientDBdata?.currentNote?.data?.assessment?.[diagnosisName]?.assessmentSuggestions || ''

    const generatedHtml = `
      <div>
        <div style="white-space:pre-line;">
          ${rawText || ''}
        </div>
      </div>
    `

    setIsHavingAssessmentSuggestions(Boolean(rawText.length))
    const initialHtml = savedHtml || generatedHtml

    setOriginalHtml(generatedHtml)
    setTempHtml(initialHtml)

    if (!savedHtml) {
      setPatientDBdata((prev) => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...prev.currentNote.data?.freeTypesEverything,
              assessments: {
                ...(prev.currentNote.data?.freeTypesEverything?.assessments || {}),
                [diagnosisName]: {
                    ...prev.currentNote.data?.freeTypesEverything?.assessments?.[diagnosisName],
                  assessmentSuggestions: generatedHtml,
                }
              },
            },
          },
        },
      }))
    }
  }, [diagnosisName])

  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            assessments:{
                ...(prev.currentNote.data?.freeTypesEverything?.assessments || {}),
                [diagnosisName]: {
                    ...prev.currentNote.data?.freeTypesEverything?.assessments?.[diagnosisName],
                  assessmentSuggestions: tempHtml, 
                }
            }
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteID) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
                assessments:{
                    ...(parsedData.freeTypesEverything?.assessments || {}),
                    [diagnosisName]: {
                        ...parsedData.freeTypesEverything?.assessments?.[diagnosisName],
                      assessmentSuggestions: tempHtml, 
                    },
                    },
            },
          }),
        }
      }),
    }))
  }

  if(!isHavingAssessmentSuggestions) return null
  return (
      <div className="w-100 my-4">
      <div style={{ width: '30%' }}>Assessment Suggestion</div>
        <Editor
          value={tempHtml}
          onChange={(e) => setTempHtml(e.target.value)}
          onBlur={handleBlur}
          containerProps={{
            style: {
              width: '100%',
              background: '#2D2D2D',
              color: 'white',
              border: 0,
            },
          }}
        >
          <Toolbar hidden />
        </Editor>
      </div>
  )
}

export default AssessMentSuggestionRecords
